import { type FC } from 'react'

export const Footer: FC = () => {
  return (
    <div />
  )
}
